import React, { useState } from "react";
import { cn } from "../../lib/utils";
import { AppDialog } from "../../shared/ui/composites";
import { NumeralSystemToggle } from "../../shared/ui/numeral-system-toggle";
import { useNumberFormat } from "../providers/NumberFormatProvider";
import { usePreferences, THEME_DARK, THEME_LIGHT } from "../providers/PreferencesProvider";
import { applyTheme } from "../providers/theme";

export default function CustomizePopover({ collapsed = false, className }) {
  const [open, setOpen] = useState(false);
  const { numeralSystem } = useNumberFormat();
  const { theme, setTheme, setNumeralSystem, sidebarOpen, setSidebarOpen } =
    usePreferences();

  return (
    <>
      <button
        type="button"
        className={className}
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        title="سفارشی‌سازی"
        aria-label="سفارشی‌سازی"
      >
        <span aria-hidden="true">⚙</span>
        <span className={cn(collapsed && "lg:hidden")}>ظاهر</span>
      </button>

      <AppDialog
        open={open}
        onOpenChange={setOpen}
        title="سفارشی‌سازی ظاهر"
        cancelLabel="بستن"
        showFooter
      >
        <div className="mb-3">
          <p className="mb-1.5 text-xs font-bold text-slate-500">زمینه</p>
          <div className="grid grid-cols-2 gap-1.5">
            {[
              { id: THEME_LIGHT, label: "روشن", icon: "☀️" },
              { id: THEME_DARK, label: "تیره", icon: "🌙" },
            ].map((opt) => (
              <button
                key={opt.id}
                type="button"
                onClick={() => {
                  applyTheme(opt.id);
                  setTheme(opt.id);
                }}
                className={cn(
                  "flex items-center justify-center gap-1.5 rounded-xl border px-2 py-1.5 text-xs font-bold transition-colors",
                  theme === opt.id
                    ? "border-indigo-400 bg-indigo-50 text-indigo-700"
                    : "border-slate-200 text-slate-600 hover:bg-slate-50",
                )}
              >
                <span>{opt.icon}</span>
                {opt.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mb-3">
          <p className="mb-1.5 text-xs font-bold text-slate-500">نمایش اعداد</p>
          <NumeralSystemToggle
            value={numeralSystem}
            onChange={setNumeralSystem}
          />
        </div>

        <label className="flex cursor-pointer items-center justify-between gap-2 rounded-xl border border-slate-200 px-2.5 py-2 text-xs font-bold text-slate-600">
          <span>نوار کناری باز</span>
          <input
            type="checkbox"
            className="accent-indigo-600"
            checked={sidebarOpen}
            onChange={(e) => setSidebarOpen(e.target.checked)}
          />
        </label>
      </AppDialog>
    </>
  );
}
